import React from "react";
import { ArrowRight } from "lucide-react";
import logo from "../assets/logo.png";

const Header = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white border-opacity-25">
      <div className="px-[7.6923%] h-20 flex items-center justify-between">
        <div className="flex items-center">
          <img
            src={logo}
            alt="Frontroom Websites"
            className="h-16 object-contain cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          />
        </div>

        <nav className="hidden md:flex items-center gap-8">
          <button
            onClick={() => scrollToSection("work")}
            className="text-[#4D4D4D] hover:text-white text-lg font-normal transition-colors duration-300"
          >
            Work
          </button>
          <button
            onClick={() => scrollToSection("process")}
            className="text-[#4D4D4D] hover:text-white text-lg font-normal transition-colors duration-300"
          >
            Process
          </button>
          <a
            href="mailto:hello@frontroom.website"
            className="bg-[#00FFD1] text-black px-6 py-3.5 text-lg font-medium transition-all duration-400 hover:bg-white hover:text-black flex items-center gap-3 min-h-14"
          >
            Contact
            <ArrowRight size={20} />
          </a>
        </nav>

        <nav className="flex md:hidden">
          <a
            href="mailto:hello@frontroom.website"
            className="bg-[#00FFD1] text-black px-5 py-3 text-base font-medium transition-all duration-400 hover:bg-white"
          >
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
